import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const Dropdown = components.base.Dropdown.Dropdown;

function rawCssPrefix(props: unknown): string {
	return `

	`;
}

export default InjectedStyledComponent(
	Dropdown,
	'columnSelector',
	['dropdownComponent'],
	['appStore'],
	rawCssPrefix,
	undefined,
);
